// extracted by mini-css-extract-plugin
export default {"CanonicalTag":"CanonicalTag--D9Bf7"};